import LiquidityEngineAPIClient from '../liquidityEngineAPIClient';

/**
 * Cash Positioning API client.
 * Wraps the LiquidityEngineAPIClient with typed methods for each cash positioning endpoint.
 */
const CashPositioningAPIClient = {

    getAgentSummary: async (region?: string, date?: string) => {
        const params: Record<string, string> = {};
        if (region) params.region = region;
        if (date) params.date = date;
        return LiquidityEngineAPIClient.invoke('GET', 'cash-positioning/agent-summary', params);
    },

    getZbaPositioning: async (region: string, date: string) => {
        return LiquidityEngineAPIClient.invoke('GET', 'cash-positioning/zba-positioning', { region, date });
    },

    getAqPositioning: async (region: string, date: string) => {
        return LiquidityEngineAPIClient.invoke('GET', 'cash-positioning/aq-positioning', { region, date });
    },

    getVariances: async (region: string, date: string) => {
        return LiquidityEngineAPIClient.invoke('GET', 'cash-positioning/variances', { region, date });
    },

    getTransactions: async (account: string, date: string) => {
        return LiquidityEngineAPIClient.invoke('GET', 'cash-positioning/transactions', { account, date });
    },

    getLedgerBalances: async (account: string, date: string) => {
        return LiquidityEngineAPIClient.invoke('GET', 'cash-positioning/ledger-balances', { account, date });
    },

    getProcessingStatus: async (region?: string) => {
        const params: Record<string, string> = {};
        if (region) params.region = region;
        return LiquidityEngineAPIClient.invoke('GET', 'cash-positioning/status', params);
    },

    getDecisionsByDate: async (date: string, region?: string) => {
        const params: Record<string, string> = {};
        if (region) params.region = region;
        return LiquidityEngineAPIClient.invoke('GET', `cash-positioning/decisions/date/${date}`, params);
    },

    getDecisionsByAccount: async (accountId: string, fromDate?: string, toDate?: string) => {
        const params: Record<string, string> = {};
        if (fromDate) params.fromDate = fromDate;
        if (toDate) params.toDate = toDate;
        return LiquidityEngineAPIClient.invoke('GET', `cash-positioning/decisions/account/${accountId}`, params);
    },

    queryCashPositioning: async (question: string) => {
        // Cast needed because the JS client's body param defaults to null,
        // causing TS to infer its type as null rather than any.
        const client = LiquidityEngineAPIClient as { invoke: (method: string, path: string, queryParams: Record<string, string>, body: unknown) => Promise<unknown> };
        return client.invoke('POST', 'cash-positioning/query', {}, { question });
    },
};

export default CashPositioningAPIClient;
